export default "__VITE_ASSET__C2I16uFN__"